class AddizionaleRegionale {

    getCluster( regione, classificazioneClimatica ){
        let zona = [
            0, 0, 0, 0
        ];
        switch (regione) {
            case 'Piemonte':
                zona = [0.022, 0.0258, 0.0258, 0.0258];
            break;
            case 'Veneto':
                zona = [0.007747, 0.023241, 0.025823, 0.030987];
            break;
            case 'Liguria': 
                zona = (classificazioneClimatica == 'E') ? [0.0155, 0.0155, 0.0155, 0.0155] : 
                     ( (classificazioneClimatica == 'F') ? [0.0103, 0.0103, 0.0103, 0.0103] : [0.022, 0.0258, 0.0258, 0.0258] );
            break;
            case 'Emilia-Romagna':
                zona = [0.022, 0.0309874, 0.0309874, 0.0309874];
            break;
            case 'Toscana':
                zona = [0.022, 0.030987, 0.030987, 0.030987];
            break;
            case 'Umbria':
                zona = [0.05165, 0.05165, 0.05165, 0.05165];
            break;
            case 'Marche':
                zona = [0.01557, 0.0181, 0.0207, 0.0258];
            break;
            case 'Lazio':
                zona = [0.019, 0.03099, 0.03099, 0.03099];
            break;
            case 'Abruzzo':
                zona = (classificazioneClimatica == 'E') ? [0.01033, 0.01033, 0.01033, 0.01033] : 
                     ( (classificazioneClimatica == 'F') ? [0.01033, 0.01033, 0.01033, 0.01033] : [0.019, 0.023241, 0.025823, 0.025823] );
            break;
            case 'Molise':
                zona = [0.019, 0.030987, 0.030987, 0.030987];
            break;
            case 'Campania':
                zona = [0.019, 0.031, 0.031, 0.031];
            break
            case 'Puglia':
                zona = [0.019, 0.03098, 0.03098, 0.03098];
            break
            case 'Basilicata':
                zona = [0.019, 0.0258228, 0.0258228, 0.0258228];
            break
            case 'Calabria':
                zona = [0.019, 0.02582, 0.02582, 0.02582];
            break
            default:
                // do nothing we are already in the right zone
                break;
        }

        return {
            'scaglioni': zona
        };
    }

}
export default new AddizionaleRegionale();